export default "__VITE_ASSET__a837c17c__"